// @flow
import React from 'react';
import styled from 'react-emotion';
import { paymentOptions, colors } from '../assets/scripts/constants';

const Container = styled('div')`
  display: ${({ mobile }) => (mobile ? 'block' : 'none')};
  order: 2;
  margin-top: ${({ mobile }) => (mobile ? '0' : '1em')};
  padding-top: 2em;
  text-align: center;
  border-top: ${({ mobile }) =>
    mobile ? 'none' : `1px solid ${colors.grayLight}`};

  @media (min-width: 860px) {
    display: ${({ mobile }) => (mobile ? 'none' : 'block')};
    order: unset;
  }
`;

export default function PaymentOptions(
  {
    mobile,
  }: {
    mobile?: boolean,
  } = { mobile: false }
) {
  return (
    <Container mobile={mobile}>
      {paymentOptions.map((bank, i) => (
        <img
          src={`/wp-content/themes/eclisse/dist/images/icon-bank-${i +
            1}-dark.png`}
          alt={bank}
          key={bank}
        />
      ))}
    </Container>
  );
}



// WEBPACK FOOTER //
// ./src/components/PaymentOptions.js